import { render } from "./Variants Type.vue?vue&type=template&id=5f571170"
import script from "./Variants Type.vue?vue&type=script&lang=js"
export * from "./Variants Type.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__